import React, { useEffect, useRef, useMemo, useState } from "react";

import Footer from "./Components/Footer";
import Header from "./Components/Header";
import eye from "../assets/images/Eye.svg";
import { BsEye, BsFileEarmarkXFill } from "react-icons/bs";

import noFile from "../assets/images/noFile.svg";
import "../index.css";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DataTable from "react-data-table-component";
import star from "../assets/images2/star.svg";
import editImage from "../assets/images2/editColored.svg";
import editImagedisable from "../assets/images2/editDisable.svg";

import Modal from "react-modal";
import { Link, useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import closeModal from "../assets/images/CloseModel.svg";
import { FaSort } from "react-icons/fa";
import secureLocalStorage from "react-secure-storage";
import Routes from "./Components/data/remote/Routes";
import moment from "moment";
import { Puff } from "react-loader-spinner";
import { toast, ToastContainer } from "react-toastify";
import { Tooltip } from "react-tooltip";
import dayjs from "dayjs";
import { UnAuthModal } from "../reuseable/UnAuthModal";
import { checkAuth } from "../reuseable/UnAuthFunction";

const customSortIcon = (sortDirection) => {
  if (sortDirection === "asc") {
    return <FaSort className="" />;
  } else if (sortDirection === "desc") {
    return <FaSort className="" />;
  } else {
    return null;
  }
};

const Saved = () => {
  // const [showbtn, setShowBtn ] = (false)
  const navigate = useNavigate();

  const [visible, setVisible] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [showIcon, setShowIcon] = useState([]);
  const [search, setSearch] = useState("");
  const [searchText, setSearchText] = useState("");
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const dropdownRef = useRef(null);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [requestType, setRequestType] = useState(null);

  const handleSort = (column, sortDirection) => {
    setSortColumn(column.selector);
    setSortDirection(sortDirection);
  };

  const toggleOptions = () => {
    setShowOptions(!showOptions);
  };
  useEffect(() => {
    if (!accessToken) {
      navigate("/");
    }
    checkAuth();
  }, []);

  useEffect(() => {
    const handleClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowOptions(false);
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

  const today = new Date();

  const oncloseModal = () => {
    setSelectedRow(null);
    setSelectedRow2(null);
    disablefields(false);
    disablefields2(false);
  };

  const [showOptions, setShowOptions] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");

  const [page3, setPage3] = useState(0);
  const [perPage3, setPerPage3] = useState(10);

  const options = [
    { name: "ASAB Phase-II" },
    { name: "PACKAGE-C" },
    { name: "RUMAITHA" },
    { name: "BUHASA" },
    { name: "ASR Project" },
    { name: "BUHASA" },
    { name: "ASR Project" },
    { name: "ASR Project" },
    { name: "RUMAITHA" },
    { name: "BUHASA" },
  ];

  const [selectedSkill, setSelectedSkill] = useState("");
  const [dropdownSearchValue, setDropdownSearchValue] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  // const [userID, setUserId] = useState('');

  const [isOpen, setIsOpen] = useState(false);
  const userID = secureLocalStorage.getItem("userLevel");

  const notify = (message, type) => {
    // alert('error', +message)
    type == "success"
      ? toast.success(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      })
      : toast.error(message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
  };
  // close model method
  const handleCloseModal = () => {
    setIsOpen(false);
    notify("The Request IMR, ASR-1000001 has been cancelled ", "success");
  };

  const handleCloseModal2 = () => {
    setIsOpen(false);
  };

  const handleClick = (value, action, row) => {
    if (row.request_type == "1") {
      navigate("/view-isr", {
        state: { myBooleanValue: value, data: row, action: action },
      });
    } else if (row.request_type == "0") {
      navigate("/view-imr", {
        state: { myBooleanValue: value, action: action, data: row },
      });
    }
  };


  const skills = [
    { name: "ASAB Phase-II" },
    { name: "PACKAGE-C" },
    { name: "RUMAITHA" },
    { name: "BUHASA" },
    { name: "ASR Project" },
  ];

  const customColumns = [
    {
      id: 2,
      name: "Project",
      selector: "Project",
      sortable: true,
    },
    {
      id: 3,
      name: "ISR No",
      selector: "ISRNo",
      sortable: true,
    },
    {
      id: 4,
      name: "ISR Date",
      selector: "ISRDate",
      sortable: true,
    },
    {
      id: 5,
      name: "Service from Date",
      selector: "ServicefromDate",
      sortable: true,
    },
    {
      id: 6,
      name: "Attachments",
      selector: "Attachments",
      sortable: true,
    },
    {
      id: 7,
      name: "Status",
      selector: "Status",
      sortable: true,
    },

    {
      id: 8,
      name: "PR Number",
      selector: "PRNumber",
      sortable: true,
    },

    {
      id: 9,
      name: "PO Number",
      selector: "PONumber",
      sortable: true,
    },
  ];

  const dummyArray2 = [
    {
      id: "1",
      Project: "ASAB Phase ll",
      ISRNo: "AS2-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "SELF",
      ServiceDate: "13-Jan-2023",
      ActingAs: "USER",
      RequiredDeliveryDate: "19-Jan-2023",
      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "2",
      Project: "PACKAGE-C2",
      ISRNo: "PCK-20000012",
      ISRDate: "14-Jan-2023",
      ReleasedBy: "SELF",
      ServiceDate: "14-Jan-2023",
      ActingAs: "USER",
      RequiredDeliveryDate: "19-Jan-20232",
      Attachments: "Maps2.pdf",
      Status: "Approved2",
      PRNumber: "PR-AS2-2000001012",
      PONumber: "PO-AS2-2000001012",
    },
    {
      id: "3",
      Project: "PACKAGE-C2",
      ISRNo: "PCK-20000022",
      ISRDate: "15-Jan-2023",
      ReleasedBy: "SELF",
      ActingAs: "USER",
      ServiceDate: "15-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",

      Attachments: "Maps3.pdf",
      Status: "Approved3",
      PRNumber: "PR-AS2-2000001013",
      PONumber: "PO-AS2-2000001013",
    },
    {
      id: "4",
      Project: "BUHASA4",
      ISRNo: "BHS-20000014",
      ISRDate: "13-Jan-2023",
      ReleasedBy: "SELF",
      ActingAs: "APPROVER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "20-Jan-2023",
      Attachments: "Maps4.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-2000001014",
      PONumber: "PO-AS2-2000001014",
    },
    {
      id: "5",
      Project: "ASR Project",
      ISRNo: "ASR-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "SELF",
      ActingAs: "VIEWER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",

      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "6",
      Project: "ASR Project",
      ISRNo: "ASR-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "SELF",
      ActingAs: "USER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",
      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "7",
      Project: "ASR Project",
      ISRNo: "ASR-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "SELF",
      ActingAs: "USER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",
      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "8",
      Project: "PACKAGE-C",
      ISRNo: "PCK-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "Salman Khan",
      ActingAs: "APPROVER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",

      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "9",
      Project: "PACKAGE-C",
      ISRNo: "PCK-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "Wassi",
      ActingAs: "VIEWER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",

      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "10",
      Project: "PACKAGE-C",
      ISRNo: "PCK-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "27-Feb-2023",
      ActingAs: "USER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",

      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "11",
      Project: "ASR Project",
      ISRNo: "ASR-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "27-Feb-2023",
      ActingAs: "USER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",

      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "12",
      Project: "ASR Project",
      ISRNo: "ASR-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "27-Feb-2023",
      ActingAs: "USER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",

      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "13",
      Project: "ASR Project",
      ISRNo: "ASR-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "27-Feb-2023",
      ActingAs: "USER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",

      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "14",
      Project: "ASR Project",
      ISRNo: "ASR-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "27-Feb-2023",
      ActingAs: "USER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",

      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "15",
      Project: "ASR Project",
      ISRNo: "ASR-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "27-Feb-2023",
      ActingAs: "USER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",

      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "16",
      Project: "ASAB Phase ll",
      ISRNo: "AS2-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "27-Feb-2023",
      ActingAs: "USER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",

      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "17",
      Project: "ASAB Phase ll",
      ISRNo: "AS2-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "27-Feb-2023",
      ActingAs: "USER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",

      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "18",
      Project: "ASAB Phase ll",
      ISRNo: "AS2-2000001",
      ISRDate: "12-Jan-2023",
      ServicefromDate: "12-Feb-2023",
      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "19",
      Project: "ASR Project",
      ISRNo: "ASR-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "27-Feb-2023",
      ActingAs: "USER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",

      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "20",
      Project: "ASR Project",
      ISRNo: "ASR-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "27-Feb-2023",
      ActingAs: "USER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",

      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "21",
      Project: "ASR Project",
      ISRNo: "ASR-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "27-Feb-2023",
      ActingAs: "USER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",

      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "22",
      Project: "ASR Project",
      ISRNo: "ASR-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "27-Feb-2023",
      ActingAs: "USER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",

      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "23",
      Project: "ASAB Phase ll",
      ISRNo: "AS2-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "27-Feb-2023",
      ActingAs: "USER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",

      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "24",
      Project: "ASAB Phase ll",
      ISRNo: "AS2-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "27-Feb-2023",
      ActingAs: "USER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",

      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "25",
      Project: "ASAB Phase ll",
      ISRNo: "AS2-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "27-Feb-2023",
      ActingAs: "USER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",

      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "26",
      Project: "ASAB Phase ll",
      ISRNo: "AS2-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "27-Feb-2023",
      ActingAs: "USER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",

      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
    {
      id: "27",
      Project: "ASR Project",
      ISRNo: "ASR-2000001",
      ISRDate: "12-Jan-2023",
      ReleasedBy: "27-Feb-2023",
      ActingAs: "USER",
      ServiceDate: "13-Jan-2023",
      RequiredDeliveryDate: "19-Jan-2023",

      Attachments: "Maps.pdf",
      Status: "Approved",
      PRNumber: "PR-AS2-200000101",
      PONumber: "PO-AS2-200000101",
    },
  ];

  const columns2 = [
    {
      id: 1,
      name: "Serial No",
      selector: (row, index) => page3 * perPage3 + index + 1,
      sortable: true,
    },
    {
      id: 2,
      name: "Project",
      selector: (row) => row?.projects?.project_name,
      sortable: true,
      // cell: (row) => (
      //   <EditableCell
      //     row={row}
      //     fields={['Project']}
      //     editingRowId={editingRowId}
      //     handleCellChange={handleCellChange}
      //   />
      // ),
    },
    {
      id: 3,
      name: "IMR No",
      selector: (row) => row?.request_number,
      sortable: true,
      // cell: (row) => (
      //   <EditableCell
      //     row={row}
      //     fields={['ISRNo']}
      //     editingRowId={editingRowId}
      //     handleCellChange={handleCellChange}
      //   />
      // ),
    },
    {
      id: 4,
      name: "IMR Date",
      selector: (row) => moment(row?.created_at).format("DD-MM-YYYY"),
      sortable: true,
      // cell: (row) => (
      //   <EditableCell
      //     row={row}
      //     fields={['ISRDate']}
      //     editingRowId={editingRowId}
      //     handleCellChange={handleCellChange}
      //   />
      // ),
    },

    // {
    //   id: 6,
    //   name: "Released date",
    //   selector: (row) => row?.ServiceDate,
    //   sortable: true,
    //   cell: (row) => (
    //     <EditableCell
    //       row={row}
    //       fields={['ServiceDate']}
    //       editingRowId={editingRowId}
    //       handleCellChange={handleCellChange}
    //     />
    //   ),
    // },

    // {
    //   id: 5,
    //   name: "Released by",
    //   selector: (row) => row?.ReleasedBy,
    //   sortable: true,
    //   cell: (row) => (
    //     <EditableCell
    //       row={row}
    //       fields={['ReleasedBy']}
    //       editingRowId={editingRowId}
    //       handleCellChange={handleCellChange}
    //     />
    //   ),
    // },

    {
      id: 5,
      name: "Acting as",
      selector: (row) => row?.role,
      sortable: true,
      cell: (row) => (
        <EditableCell
          row={row}
          fields={["role"]}
          editingRowId={editingRowId}
          handleCellChange={handleCellChange}
        />
      ),
    },

    {
      id: 7,
      name: "Required Delivery Date",
      selector: (row) =>
        row?.material?.delivary_date
          ? dayjs(row.material.delivary_date).format("DD-MM-YYYY")
          : "No date found",
      sortable: true,
      // cell: (row) => (
      //   <EditableCell
      //     row={row}
      //     fields={['RequiredDeliveryDate']}
      //     editingRowId={editingRowId}
      //     handleCellChange={handleCellChange}
      //   />
      // ),
    },
    {
      id: 8,
      name: "Attachments",
      selector: (row) =>
        row?.document?.name ? row?.document?.name : "No attachments",
      sortable: true,
      cell: (row) =>
        row?.document?.name ? (
          <a
            data-tooltip-content="Preview Image"
            className="my-element"
            href={row?.document?.url}
            download
            target="_blank"
          >
            {row?.document?.name}
          </a>
        ) : (
          <p className="noAttachment">No attachments</p>
        ),
      // cell: (row) => (
      //   <EditableCell
      //     row={row}
      //     fields={['Attachments']}
      //     editingRowId={editingRowId}
      //     handleCellChange={handleCellChange}
      //   />
      // ),
    },
    {
      id: 9,
      name: "Status",
      selector: (row) => row?.stage,
      sortable: true,
      cell: (row) => (
        <EditableCell
          row={row}
          fields={["stage"]}
          editingRowId={editingRowId}
          handleCellChange={handleCellChange}
        />
      ),
    },
    {
      id: 10,
      name: "Quick Action",
      // cell: row => <div className='editTrashImage'>
      //   <img src={editImage} alt='editImage' />
      //   <img src={trash} alt='editImage' />

      // </div>,
      cell: (row) => (
        <>
          <div className="d-flex">
            <div className="col">
              {/* {console.log('RowData--->', row)} */}

              {/* {filterCurentLevel = row.projects.approver?.filter((f) => f.level == row.current_level)} */}
              {row.projects.status == "1" ? (
                row?.role != "Viewer" ? (
                  row?.role != "User" ? (
                    row.current_level == "request has not been submitted" ? (
                      <div>
                        <BsEye size={20} />
                      </div>
                    ) : (
                      <div onClick={() => handleClick(1, 1, row)}>
                        {row?.projects?.approver
                          ?.filter((val) =>
                            val?.pivot?.level
                              ?.toLowerCase()
                              .includes(row?.current_level)
                          )
                          .map((fil, index) => {
                            return JSON.stringify(userID) ===
                              fil?.pivot?.user_id && row?.is_released == 1 ? (
                              <img
                                data-tooltip-content="Preview Request"
                                className="editImageIcon my-element"
                                src={eye}
                                alt="eye"
                              />
                            ) : (
                              <BsEye size={20} />
                            );
                          })}
                      </div>
                    )
                  ) : (
                    <div onClick={() => handleClick(1, 1, row)}>
                      <img
                        data-tooltip-content="Preview Request"
                        className="editImageIcon my-element"
                        src={eye}
                        alt="eye"
                      />
                    </div>
                  )
                ) : (
                  <div onClick={() => handleClick(1, 1, row)}>
                    <img
                      data-tooltip-content="Preview Request"
                      className="editImageIcon my-element"
                      src={eye}
                      alt="eye"
                    />
                  </div>
                )
              ) : (
                <BsEye size={20} />
              )}
            </div>
            <div className="col">
              {/* {row.projects.status == "1" ? (
                <img
                  onClick={() => setIsOpen(true)}
                  data-tooltip-content="Cancel Request"
                  className="editImageIcon ms-1 my-element"
                  src={noFile}
                  alt="trash"
                />
              ) : ( */}
              <BsFileEarmarkXFill
                className="my-element"
                data-tooltip-content="This feature will be implemented in second phase"
                fontSize={"20px"}
                color="#e0dfdc"
              />

              {/* <img src={noFile} className="ms-1" disabled alt="trash" /> */}
              {/* )} */}
            </div>
            <div className="col">
              {row.projects.status == "1" ? (
                <EditButton
                  row={row}
                  editingRowId={editingRowId}
                  handleEditClick={handleEditClick}
                />
              ) : (
                <EditButton
                // row={row}
                // editingRowId={editingRowId}
                // handleEditClick={handleEditClick}
                />
              )}
            </div>
          </div>
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      sortable: true,
    },
    // {
    //   id: 11,
    //   name: "PR Number",
    //   selector: (row) => row?.PRNumber,
    //   sortable: true,

    //   cell: (row) => (
    //     <EditableCell
    //       row={row}
    //       fields={['PRNumber']}
    //       editingRowId={editingRowId}
    //       handleCellChange={handleCellChange}
    //     />
    //   ),
    // },

    // {
    //   id: 12,
    //   name: "PO Number",
    //   selector: (row) => row?.PONumber,
    //   sortable: true,
    //   cell: (row) => (
    //     <EditableCell
    //       row={row}
    //       fields={['PONumber']}
    //       editingRowId={editingRowId}
    //       handleCellChange={handleCellChange}
    //     />
    //   ),
    // },
  ];

  const [data, setData] = useState([]);

  const filteredData = useMemo(() => {
    let result = dummyArray2;

    // Apply date range filter
    if (startDate && endDate) {
      result = result.filter((row) => {
        const serviceDate = new Date(row.ServiceDate);
        return serviceDate >= startDate && serviceDate <= endDate;
      });
    }

    // Apply search filter
    if (search) {
      const searchTextLower = search.toLowerCase();
      result = result.filter((row) => {
        return Object.values(row).some((val) =>
          String(val).toLowerCase().includes(searchTextLower)
        );
      });
    }

    return result;
  }, [startDate, endDate, search]);
  const accessToken = secureLocalStorage.getItem("token");

  const FetchImrRequests = () => {
    setLoading(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + accessToken);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(Routes.savedRequest, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.success) {
          // setTableData(result?.data);
          getApproverData(result?.data);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setLoading(false);
      });
  };
  const getApproverData = (data) => {
    const updatedArray = data.filter((obj) => {
      return (
        (obj.role === "Approver" && obj.stage !== "saved") ||
        obj.role === "User" ||
        (obj.role == "Viewer" && obj.stage !== "saved")
      );
    });

    setTableData(updatedArray);
    console.log(updatedArray);
  };
  useEffect(() => {
    FetchImrRequests();
    const checkIfClickedOutside = (e) => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (
        editMode &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        setEditMode(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [editMode]);

  const [disablefields, setDisableFields] = useState(false);
  const [disablefields2, setDisableFields2] = useState(false);

  const skillSelectionHandler = (skill) => {
    // alert(skills)
    setSelectedSkill(skill);
    setSelectedProject(skill);
    setEditMode(false);
    setDropdownSearchValue("");
    toggleOptions();
  };

  // const skillSelectionHandler = (skill) => {
  //   setSelectedProject(skill);
  //   setSelectedSkill(skill);
  //   setEditMode(false);
  //   setDropdownSearchValue(""); // clear the search value
  //   toggleOptions(); // close the dropdown menu
  // };

  // const handleOptionSelect = (option) => {
  //   setSelectedOption(option);
  //   setShowOptions(false);
  // };

  useEffect(() => { }, []);

  const handleToggle = () => {
    setVisible(false);
  };

  const handleToggle2 = () => {
    setVisible(true);
  };

  const onClickshowIcon = (item) => {
    let index = showIcon.findIndex((x) => x === item.id);
    if (index >= 0) showIcon.splice(index, 1);
    else showIcon.push(item.id);
    setShowIcon([...showIcon]);
  };

  const handleImageClick = (row) => {
    setShowIcon(!showIcon);
  };

  const [filterCountries, setFilterCountries] = useState([]);

  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [showTableTwo, setShowTableTwo] = useState(false);
  const [projects, setProjects] = useState([]);
  const [checkValue, setCheckValue] = useState(false);

  const filteredSkills = projects.filter((skill) =>
    skill.project_name.match(new RegExp(dropdownSearchValue, "i"))
  );

  const CustomPagination2 = ({ page3, perPage3, setPage3, filteredData }) => {
    const handlePrev = () => {
      if (page3 > 0) {
        setPage3(page3 - 1);
      }
    };

    const handleNext = () => {
      if (page3 < Math.ceil(filteredData.length / perPage3) - 1) {
        setPage3(page3 + 1);
      }
    };

    // Calculate the start and end indices of the current page based on the full data array
    const startIndex = page3 * perPage3;
    const endIndex = Math.min(filteredData?.length, (page3 + 1) * perPage3);

    return (
      <div className="customPaginationMain">
        <div>
          Showing {startIndex + 1} to {endIndex} of {filteredData?.length}{" "}
          entries
        </div>
        <div className="PaginationButtonMain">
          <button className="paginationButtons" onClick={handlePrev}>
            Previous
          </button>
          {Array.from(
            { length: Math.ceil(filteredData?.length / perPage3) },
            (_, i) => {
              if (
                Math.abs(i - page3) <= 2 ||
                i === 0 ||
                i === Math.ceil(filteredData?.length / perPage3) - 1
              ) {
                // Show the current page and the two adjacent pages, or the first and last pages
                return (
                  <button
                    key={i}
                    onClick={() => setPage3(i)}
                    className={i === page3 ? "activePage" : "paginationButtons"}
                  >
                    {i + 1}
                  </button>
                );
              } else if (Math.abs(i - page3) === 3) {
                // Show an ellipsis and the last page number
                return <span key={i}>...</span>;
              } else {
                // Don't show this page number
                return null;
              }
            }
          )}
          <button className="paginationButtons" onClick={handleNext}>
            Next
          </button>
        </div>
      </div>
    );
  };

  const CustomPagination = ({ page, perPage, setPage, data }) => {
    const handlePrev = () => {
      if (page > 0) {
        setPage(page - 1);
      }
    };

    const handleNext = () => {
      if (page < Math.ceil(data.length / perPage) - 1) {
        setPage(page + 1);
      }
    };

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          paddingTop: "16px",
        }}
      >
        <div>
          Showing {page * perPage + 1} to{" "}
          {Math.min(data.length, (page + 1) * perPage)} of {data.length} entries
        </div>
        <div>
          <button className="paginationButtons" onClick={handlePrev}>
            Previous
          </button>
          {Array.from({ length: Math.ceil(data.length / perPage) }, (_, i) => (
            <button
              key={i}
              onClick={() => setPage(i)}
              className={i === page ? "active" : "paginationButtons"}
            >
              {i + 1}
            </button>
          ))}
          <button className="paginationButtons" onClick={handleNext}>
            Next
          </button>
        </div>
      </div>
    );
  };

  // useEffect(() => {
  //   if (!search) {
  //     setData(tableData);
  //   } else {
  //     const result = tableData.filter((item) =>
  //       JSON.stringify(item)
  //         .toLowerCase()
  //         .includes(search.toLowerCase())
  //     );
  //     setData(result);
  //   }
  // }, [search, tableData]);

  useEffect(() => {
    if (!search && !selectedProject && !requestType && !startDate && !endDate) {
      setData(tableData);
    } else {
      let result = tableData;
      if (search) {
        result = result.filter((item) =>
          JSON.stringify(item).toLowerCase().includes(search.toLowerCase())
        );
        setData(result);
      }
      if (selectedProject) {
        setSelectedClass("");
        setSelectedShortText("");
        setSelectedMaterialCode("");
        // console.log('useEffect---->', result.map((item) => item?.projects?.project_name), selectedProject)
        result = result.filter(
          (item) => item?.projects?.project_name === selectedProject
        );
        setData(result);
      }
      if (requestType) {
        setSelectedClass("");
        setSelectedShortText("");
        setSelectedMaterialCode("");
        result = result.filter((item) => item?.stage === requestType);
        setData(result);
      }
      if (startDate && endDate) {
        result = result.filter(
          (item) =>
            new Date(item?.created_at).getTime() >= startDate.getTime() &&
            new Date(item?.created_at).getTime() <= endDate.getTime()
        );
      }
      setData(result);
    }
  }, [search, selectedProject, tableData, requestType, startDate, endDate]);

  // const handleButtonClick = (type) => {
  //   setRequestType(type);
  //   setPage3(0)
  // };
  const handleButtonClick = (type) => {
    setPage3(0);
    if (type === null) {
      setRequestType(null);
    } else {
      setRequestType(type);
    }
    window.scrollTo(0, document.body.scrollHeight);
  };

  const filterServiceFromDate = (row) => {
    if (!startDate || !endDate) {
      return true;
    }
    const ServiceDate = new Date(row.ServiceDate);
    return ServiceDate >= startDate && ServiceDate <= endDate;
  };
  // const filteredData = dummyArray2.filter(filterServiceFromDate);

  const [selectedRow, setSelectedRow] = useState(null);
  const [editedRow, setEditedRow] = useState(null);

  const [selectedRow2, setSelectedRow2] = useState(null);
  const [editedRow2, setEditedRow2] = useState(null);

  const [editingRowId, setEditingRowId] = useState(null);
  const [editingRowId2, setEditingRowId2] = useState(null);
  const [selectedMaterialCode, setSelectedMaterialCode] = useState(null);
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedShortText, setSelectedShortText] = useState(null);
  const [selectedOption3, setSelectedOption3] = useState(null);

  const handleMaterialCodeAccordionItemClick = (item) => {
    setSelectedMaterialCode(item);
    // Update state for all filters
    setSelectedClass("");
    setSelectedShortText("");
  };

  const handleShortTextAccordionItemClick = (item) => {
    setSelectedShortText(item);
    // Update state for all filters
    setSelectedMaterialCode("");
    setSelectedClass("");
  };
  const handleEditClick = (rowId) => {
    setEditingRowId(rowId);
  };
  const [isOpen3, setIsOpen3] = useState(false);

  const handleClassAccordionItemClick = (item) => {
    setSelectedClass(item);
    // Update state for all filters
    setSelectedMaterialCode("");
    setSelectedShortText("");
  };
  const handleEditClick2 = (rowId) => {
    setEditingRowId2(rowId);
  };

  const handleCellChange = (rowId, values) => {
    const updatedData = dummyArray2.map((row) => {
      if (row.id === rowId) {
        return { ...row, ...values };
      } else {
        return row;
      }
    });
    setData(updatedData);
    setEditingRowId(null);
  };
  // const handleCellChange2 = (rowId, values) => {
  //   const updatedData = dummyArray2.map((row) => {
  //     if (row.id === rowId) {
  //       return { ...row, ...values };
  //     } else {
  //       return row;
  //     }
  //   });
  //   setData2(updatedData);
  //   setEditingRowId(null);
  // };

  // const [data2, setData2] = useState(dummyArray2);

  const EditableCell = ({ row, fields, editingRowId, handleCellChange }) => {
    const [values, setValues] = useState(
      fields.reduce((acc, field) => {
        return {
          ...acc,
          [field]: row[field],
        };
      }, {})
    );

    const handleBlur = () => {
      if (editingRowId === row.id) {
        handleCellChange(row.id, values);
      }
    };

    const handleChange = (event) => {
      const { name, value } = event.target;
      setValues({
        ...values,
        [name]: value,
      });
    };

    const handleDateChange = (date, name) => {
      setValues({
        ...values,
        [name]: date,
      });
    };

    const renderDatepicker = (field) => {
      return (
        <div className="date-picker-container">
          <DatePicker
            selected={values[field]}
            onChange={(date) => handleDateChange(date, field)}
            name={field}
            dateFormat="dd/MM/yyyy"
            onBlur={handleBlur}
            disabled={editingRowId !== row.id}
            showPopperArrow={false}
            minDate={today}
            calendarClassName="date-picker-calendar"
          />
          {/* <FaCalendarAlt className="calendar-icon" /> */}
          <img src={eye} style={{ padding: 10 }} />
        </div>
      );
    };
    return fields.map((field) => (
      <input
        className={editingRowId ? "inputFiledDesign" : "editDataInputnoFocus"}
        key={`${row.id}-${field}`}
        type="text"
        name={field}
        value={values[field]}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={editingRowId !== row.id}
      />
    ));
  };
  const EditableCell2 = ({ row, fields, editingRowId2, handleCellChange2 }) => {
    const [values, setValues] = useState(
      fields.reduce((acc, field) => {
        return {
          ...acc,
          [field]: row[field],
        };
      }, {})
    );

    const handleBlur = () => {
      if (editingRowId === row.id) {
        handleCellChange2(row.id, values);
      }
    };

    const handleChange = (event) => {
      const { name, value } = event.target;
      setValues({
        ...values,
        [name]: value,
      });
    };

    const handleDateChange = (date, name) => {
      setValues({
        ...values,
        [name]: date,
      });
    };

    const handleMaterialCodeAccordionItemClick = (item) => {
      setSelectedMaterialCode(item);
      // Update state for all filters
      setSelectedClass("");
      setSelectedShortText("");
    };

    const renderDatepicker = (field) => {
      return (
        <div className="date-picker-container">
          <DatePicker
            selected={values[field]}
            onChange={(date) => handleDateChange(date, field)}
            name={field}
            dateFormat="dd/MM/yyyy"
            onBlur={handleBlur}
            disabled={editingRowId2 !== row.id}
            showPopperArrow={false}
            calendarClassName="date-picker-calendar"
          />
          {/* <FaCalendarAlt className="calendar-icon" /> */}
          <img src={eye} style={{ padding: 10 }} />
        </div>
      );
    };

    return fields.map((field) => (
      <input
        className={editingRowId2 ? "inputFiledDesign" : "editDataInputnoFocus"}
        key={`${row.id}-${field}`}
        type="text"
        name={field}
        value={values[field]}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={editingRowId2 !== row.id}
      />
    ));
  };

  const EditButton = ({ row, editingRowId, handleEditClick }) => {
    const isEditable =
      (row?.stage === "saved" || row?.stage === "Returned") &&
      row?.role === "User";

    if (!isEditable) {
      return (
        <div>
          <img
            style={{ width: "25px" }}
            className="editImageIcon"
            src={editImagedisable}
            alt="editImagedisable"
          />
        </div>
      ); // Return null to render nothing
    }

    if (editingRowId === row.id) {
      return (
        <div>
          <img
            data-tooltip-content="Edit Request"
            className="editImageIcon my-element"
            onClick={() => handleClick(1, 2, row)}
            src={editImage}
            alt="editImage"
          />
        </div>
      );
    } else {
      return (
        <div>
          <img
            data-tooltip-content="Edit Request"
            className="editImageIcon my-element"
            onClick={() => handleClick(1, 2, row)}
            src={editImage}
            alt="editImage"
          />
        </div>
      );
    }
  };

  const EditButton2 = ({ row, editingRowId2, handleEditClick2 }) => {
    if (editingRowId2 === row.id) {
      return (
        <div>
          <img
            data-tooltip-content="Edit Request"
            className="editImageIcon my-element"
            onClick={() => handleEditClick2(null)}
            src={editImage}
            alt="editImage"
          />
        </div>
      );
    } else {
      return (
        <div>
          <img
            className="editImageIcon"
            onClick={() => handleEditClick2(row.id)}
            src={editImage}
            alt="editImage"
          />
        </div>
      );
    }
  };

  const handleDelete = (row) => {
    // delete row from data array
  };
  const handleEdit = (row) => {
    setSelectedRow2(row);
    setEditedRow2(row);
    setDisableFields(true);
  };

  const handleEdit4 = (row) => {
    setDisableFields(false);
    setSelectedRow2(row);
    setEditedRow2(row);
  };

  const handleEdit2 = (row) => {
    setSelectedRow(row);
    setEditedRow(row);
    setDisableFields2(true);
  };

  const handleEdit3 = (row) => {
    // console.log(row);
    setSelectedRow(row);
    setEditedRow(row);
    setDisableFields2(false);
  };

  const handleSave = () => {
    // save editedRow to data array
    setSelectedRow(null);
  };

  const handleSave2 = () => {
    // save editedRow to data array
    setSelectedRow2(null);
  };

  useEffect(() => {
    if (selectedRow) {
      setEditedRow(selectedRow);
    }
  }, [selectedRow]);

  useEffect(() => {
    if (selectedRow2) {
      setEditedRow2(selectedRow2);
    }
  }, [selectedRow2]);
  const authModal = secureLocalStorage.getItem("authModal");
  if (authModal) {
    return <UnAuthModal />;
  }
  return (
    <div className="imrScreenMain">
      <div className="headerPosition">
        <Header />
        <div className="inner-image">
          <div
            style={{
              margin: 0,
              position: "absolute",
              top: "60px",
              bottom: "100px",
              right: 0,
              left: 0,
            }}
            className="SearchOnImage"
          >
            <div className="onImage-Text">
              <h1>Saved Requests</h1>
              {/* <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's
                <br /> standard dummy text
              </p> */}
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-5 mb-5">
        <div className="imr-list-table">
          <div className="container">
            <div className="row TableRowImr align-items-center">
              <div className="searchresultHeader mb-0 col-md-6 ">
                <h1>Saved Requests</h1>
              </div>

              <div className="col-md-6">
                <div className="custonDropdownIsr">
                  <div className="col-auto">
                    <div className="searchresultHeader-imr">
                      Search:
                      <input
                        type="text"
                        onChange={(e) => setSearch(e.target.value)}
                        className="SearchResult"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="datatable-imr large-table">
              {loading ? (
                <div className="loaderScreen">
                  <Puff
                    height={80}
                    width={80}
                    color="rgba(0, 120, 207, 1)"
                    ariaLabel="puff-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                </div>
              ) : (
                <DataTable
                  sortIcon={
                    <div className="sort-icon">
                      {customSortIcon(sortDirection)}
                    </div>
                  }
                  onSort={handleSort}
                  sortColumn={sortColumn}
                  sortDirection={sortDirection}
                  striped
                  responsive
                  columns={columns2}
                  // data={data}
                  // data={
                  //   data.length > 10
                  //     ? search
                  //       ? data
                  //       : data
                  //         ?.filter(
                  //           (item) =>
                  //             (!selectedMaterialCode ||
                  //               item.request_number ===
                  //               selectedMaterialCode.request_number) &&
                  //             (!selectedClass ||
                  //               item.role === selectedClass.role) &&
                  //             (!selectedShortText ||
                  //               item.stage === selectedShortText.stage)
                  //         )
                  //         ?.slice(page3 * perPage3, (page3 + 1) * perPage3)
                  //     : data.slice(page3 * perPage3, (page3 + 1) * perPage3)
                  // }

                  data={data
                    ?.filter(
                      (item) =>
                        (!selectedMaterialCode ||
                          item.request_number ===
                          selectedMaterialCode.request_number) &&
                        (!selectedClass || item.role === selectedClass.role) &&
                        (!selectedShortText ||
                          item.stage === selectedShortText.stage)
                    )
                    ?.slice(page3 * perPage3, (page3 + 1) * perPage3)}
                  pagination
                  fixedHeader
                  onRowClicked={() => setShowTableTwo(true)}
                  fixedHeaderScrollHeight="450px"
                  highlightOnHover
                  // ref={tableRef}
                  value={data}
                  paginationComponent={() => (
                    <CustomPagination2
                      page3={page3}
                      perPage3={perPage3}
                      setPage3={setPage3}
                      filteredData={data?.filter(
                        (item) =>
                          (!selectedMaterialCode ||
                            item.request_number ===
                            selectedMaterialCode.request_number) &&
                          (!selectedClass ||
                            item.role === selectedClass.role) &&
                          (!selectedShortText ||
                            item.stage === selectedShortText.stage)
                      )}
                    />
                  )}
                  paginationPerPage={perPage3}
                  paginationResetDefaultPage={true}
                  paginationPage={page3}
                  onChangePage={(p) => setPage3(p)}
                  onChangeRowsPerPage={(pp) => setPerPage3(pp)}
                />
              )}

              <Modal
                className="EditModal"
                isOpen={selectedRow2 !== null}
                onRequestClose={() => oncloseModal()}
              >
                {selectedRow2 && (
                  <>
                    <h1 className="text-center">View</h1>
                    {customColumns.map((column) => (
                      <div key={column.name}>
                        <div style={{ display: "grid", marginTop: "20px" }}>
                          <label>{column.name}</label>

                          {disablefields ? (
                            <input
                              disabled
                              className="editTableInput"
                              value={editedRow2[column.selector]}
                              onChange={(event) =>
                                setEditedRow2({
                                  ...editedRow2,
                                  [column.selector]: event.target.value,
                                })
                              }
                            />
                          ) : (
                            <input
                              className="editTableInput"
                              value={editedRow2[column.selector]}
                              onChange={(event) =>
                                setEditedRow2({
                                  ...editedRow2,
                                  [column.selector]: event.target.value,
                                })
                              }
                            />
                          )}
                        </div>
                      </div>
                    ))}

                    <div className="text-center pt-3">
                      {!disablefields ? (
                        <button
                          onClick={handleSave2}
                          className="editModalSave-btn"
                        >
                          Save
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                  </>
                )}
              </Modal>
            </div>
            <Modal isOpen={isOpen} className="modaliMRiSRList">
              <img
                className="close-button"
                onClick={handleCloseModal2}
                src={closeModal}
                alt="closeModal"
              />
              <h2>
                Do you want to initiate cancellation of the IMR, ASR-1000001?
              </h2>
              <label className="remarks">Remarks</label>
              <h6
                style={{
                  color: "#0078CF",
                  textTransform: "capitalize",
                  fontWeight: "700",
                  fontSize: 18,
                }}
                className="text-center"
              >
                Note: This feature will be implemented in next iteration
              </h6>
              <textarea id="remarks"></textarea>
              <div className="button-container">
                <button disabled onClick={handleCloseModal} className="yes">
                  Yes
                </button>
                <button disabled onClick={handleCloseModal2} className="no">
                  No
                </button>
              </div>
            </Modal>
          </div>
        </div>
      </div>
      <Tooltip anchorSelect=".my-element" type="dark" effect="solid" />

      <div className="content--containerRecents"></div>
      <div className="footerFooter">
        <Footer />
      </div>
    </div>
  );
};

export default Saved;
